import { en } from "./en/resources.ts";
import { es } from "./es/resources.ts";

export const resources = {
  en,
  es,
};
